import { cr_api, makeApiRequest } from './_init'
import * as Sentry from '@sentry/react'
import { LOADING, UPDATE, FAIL } from '../reducers/default'

export const sendSimulationForm = async (dispatch, fields, partnerProduct) => {
  dispatch({ type: LOADING })
  Sentry.captureEvent({
    message: 'Simulation form submitted',
    level: 'debug',
    extra: {
      ...fields,
      endpoint: '/events',
      method: 'POST',
      raw: JSON.stringify(fields),
    },
  })

  try {
    const result = await cr_api.post(`/events/?event_type=${partnerProduct}`, fields)

    Sentry.captureEvent({
      message: 'Simulation form response received',
      level: 'debug',
      extra: {
        ...result,
        raw: JSON.stringify(result),
      },
    })
    if (result.status === 200) {
      dispatch({ type: UPDATE, payload: result.data.message })
    } else {
      dispatch({ type: FAIL, payload: 'common.errors.inServerResponse' })
    }
  } catch (error) {
    Sentry.captureException(error)
    dispatch({ type: FAIL })
  }
}
export const updateEventInDomainModel = async (fields, eventId, partnerProduct, itc_retry = undefined) => {
  try {
    const partnerDetails = localStorage.getItem('partnerDetails')
    const product = JSON.parse(partnerDetails ?? '{}').product

    const result = await cr_api.put(
      `/events/${eventId}?event_type=${partnerProduct}&partner_product=${product}${itc_retry ? `&itc_retry=${itc_retry}` : ''}`,
      fields,
    )
    if (result.status === 200) {
      return { success: true, error: false, message: result.data, content: result.data }
    } else {
      Sentry.captureEvent({
        message: 'Simulation form response received',
        level: 'debug',
        extra: {
          ...result,
          raw: JSON.stringify(result),
        },
      })
      return {
        success: false,
        error: true,
        message: 'common.errors.inServerResponse',
        content: 'common.errors.inServerResponse',
      }
    }
  } catch (error) {
    Sentry.captureException(error)
    return {
      success: false,
      error: true,
      message: 'common.errors.inServerResponse',
      content: 'common.errors.inServerResponse',
    }
  }
}

export const domainEventApi = {
  updateEventAsync: async (eventId, payload, eventType, skipEventPipeline = false) => {
    const partnerDetails = localStorage.getItem('partnerDetails')
    const product = JSON.parse(partnerDetails ?? '{}').product
    return await makeApiRequest(
      cr_api,
      'put',
      `/events/${eventId}?skip_pipeline=${skipEventPipeline}&event_type=${eventType}&partner_product=${product}`,
      payload,
    )
  },
}
